<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '../icons/Icon.svelte';

	const dispatch = createEventDispatcher();

	export let show = false;
	let simulationCustomMsg = '';

	function handleClose() {
		dispatch('close');
	}

	function handleSendPreset(text) {
		dispatch('sendSimulatedMessage', text);
		handleClose();
	}

	function handleSendCustom() {
		if (!simulationCustomMsg.trim()) return;
		dispatch('sendSimulatedMessage', simulationCustomMsg.trim());
		simulationCustomMsg = '';
		handleClose();
	}
</script>

{#if show}
	<div class="modal-overlay" on:click={handleClose} role="dialog" aria-modal="true">
		<div class="modal-card sim-modal-card" on:click|stopPropagation>
			<div class="modal-header">
				<div class="sim-title-group">
					<span class="sim-badge"><Icon name="flask" size={13} /> Laboratório de Testes</span>
					<h3>Simulador de Conversa com a IA</h3>
				</div>
				<button class="close-btn" on:click={handleClose} aria-label="Fechar"><Icon name="x" size={16} /></button>
			</div>

			<div class="modal-body sim-modal-body">
				<p class="sim-desc">
					Envie mensagens simuladas como se fosse um cliente pelo celular para testar a inteligência, leitura do cardápio e criação de pedidos em tempo real.
				</p>

				<div class="sim-presets-section">
					<label class="sim-label" for="sim-input">Testes Rápidos Pré-configurados:</label>
					<div class="sim-presets-grid">
						<button
							type="button"
							class="btn-sim-preset"
							on:click={() => handleSendPreset("Boa noite, qual o cardápio de vocês?")}
						>
							<Icon name="book-open" size={13} /> Consultar Cardápio
						</button>
						<button
							type="button"
							class="btn-sim-preset"
							on:click={() => handleSendPreset("Quantos pontos eu tenho no cartão fidelidade?")}
						>
							<Icon name="award" size={13} /> Consultar Fidelidade
						</button>
						<button
							type="button"
							class="btn-sim-preset"
							on:click={() => handleSendPreset("Tem algum cupom de desconto ativo hoje?")}
						>
							<Icon name="tag" size={13} /> Perguntar por Cupons
						</button>
						<button
							type="button"
							class="btn-sim-preset highlight"
							on:click={() => handleSendPreset("Quero 2 Smash Bacon Duplo para entregar na Av Paulista 1500, vou pagar no PIX")}
						>
							<Icon name="shopping-bag" size={13} /> Simular Pedido Completo (PIX)
						</button>
					</div>
				</div>

				<div class="sim-custom-section">
					<label class="sim-label" for="sim-input">Ou Digite Qualquer Mensagem de Teste:</label>
					<div class="sim-input-row">
						<input
							id="sim-input"
							type="text"
							placeholder="Ex: Vocês entregam no centro? Tem pizza meia a meia?"
							bind:value={simulationCustomMsg}
							on:keydown={(e) => {
								if (e.key === 'Enter') handleSendCustom();
							}}
						/>
						<button
							type="button"
							class="btn-primary"
							disabled={!simulationCustomMsg.trim()}
							on:click={handleSendCustom}
						>
							Simular Envio
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}

<style>
/* MODAL DE SIMULAÇÃO */
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(15, 23, 42, 0.65);
		backdrop-filter: blur(4px);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 9999;
		padding: 16px;
	}

	.sim-modal-card {
		background: var(--neutral-surface, #FFFFFF);
		border-radius: var(--radius-lg, 16px);
		width: 600px;
		max-width: 100%;
		border: 1px solid var(--neutral-border, #E2E8F0);
		box-shadow: var(--shadow-modal, 0 20px 25px -5px rgba(0, 0, 0, 0.15));
		overflow: hidden;
	}

	.modal-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
	}

	.sim-title-group {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.sim-badge {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 11px;
		font-weight: 700;
		text-transform: uppercase;
		color: #7E22CE;
	}

	.sim-title-group h3 {
		margin: 0;
		font-size: 16px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.close-btn {
		background: var(--neutral-surface-hover, #F1F5F9);
		border: none;
		color: var(--text-secondary, #64748B);
		width: 32px;
		height: 32px;
		border-radius: 8px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.sim-modal-body {
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.sim-desc {
		margin: 0;
		font-size: 13px;
		color: var(--text-secondary, #64748B);
		line-height: 1.45;
	}

	.sim-label {
		display: block;
		font-size: 12px;
		font-weight: 700;
		color: var(--text-primary, #0F172A);
		margin-bottom: 8px;
	}

	.sim-presets-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		gap: 8px;
	}

	.btn-sim-preset {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		background: var(--neutral-surface-hover, #F8FAFC);
		border: 1px solid var(--neutral-border, #CBD5E1);
		padding: 10px 12px;
		border-radius: var(--radius-md, 10px);
		font-size: 12px;
		font-weight: 600;
		color: var(--text-secondary, #334155);
		cursor: pointer;
		transition: all 0.15s ease;
		text-align: left;
	}

	.btn-sim-preset:hover {
		background: #E2E8F0;
		color: var(--text-primary, #0F172A);
	}

	.btn-sim-preset.highlight {
		grid-column: span 2;
		background: #FAF5FF;
		border-color: #D8B4FE;
		color: #7E22CE;
		font-weight: 700;
	}

	.btn-sim-preset.highlight:hover {
		background: #7E22CE;
		color: #FFFFFF;
	}

	.sim-input-row {
		display: flex;
		gap: 8px;
	}

	.sim-input-row input {
		flex: 1;
		border: 1px solid var(--neutral-border, #CBD5E1);
		border-radius: var(--radius-md, 10px);
		padding: 10px 12px;
		font-size: 13px;
	}
	.btn-primary {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		background: #22C55E;
		color: #FFFFFF;
		font-weight: 700;
		font-size: 13px;
		padding: 10px 18px;
		border-radius: var(--radius-md, 10px);
		border: none;
		cursor: pointer;
		transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
		box-shadow: 0 2px 4px rgba(34, 197, 94, 0.2);
	}

	.btn-primary:hover:not(:disabled) {
		background: #16A34A;
		box-shadow: 0 4px 8px rgba(34, 197, 94, 0.3);
		transform: translateY(-1px);
	}

	.btn-primary:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

</style>
